export const CACHE_KEY_PIN_HASH = "pinHash";
export const CACHE_KEY_BAR_LOCATOR = "barLocator";
export const CACHE_KEY_SCANNER_ID = "scannerId";
export const CACHE_KEY_WAITER_CODE = "waiterCode";
